var $642f7badf2405784$exports = {};
$642f7badf2405784$exports = {
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};


export {$642f7badf2405784$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
